export default __webpack_public_path__ + "static/media/yjPc.6acb64c4.jpg";